import ENUMS from '../enums/registryEnums';
import { createAction } from '../../../core/js/utils/actionUtils';
import { merge } from '../../../core/js/utils/reducerUtils';
import PRODUCT_REGISTRY_ENUMS from '../../../product/js/enums/productRegistryEnums';

export function addToRegistry(payload, meta) {
    return createAction(
        PRODUCT_REGISTRY_ENUMS.ADD_TO_REGISTRY,
        merge(
            payload,
            {
                messages: {}
            }
        ),
        meta
    );
}

export function addedToRegistry(payload, meta) {
    return createAction(
        PRODUCT_REGISTRY_ENUMS.ADDED_TO_REGISTRY,
        merge(
            payload,
            {
                showProductRegistries: false
            }
        ),
        meta
    );
}

export function checkProductRegistries(payload, meta) {
    return createAction(
        ENUMS.CHECK_PRODUCT_REGISTRIES,
        payload,
        meta
    );
}

export function getRegistries(payload, meta) {
    return createAction(
        ENUMS.GET_REGISTRIES,
        payload,
        meta
    );
}

export function hideProductRegistries(payload, meta) {
    return createAction(
        PRODUCT_REGISTRY_ENUMS.HIDE_PRODUCT_REGISTRIES,
        merge(
            payload,
            {
                showProductRegistries: false
            }
        ),
        meta);
}

export function promptRegistryCreate(payload, meta) {
    return createAction(
        ENUMS.PROMPT_REGISTRY_CREATE,
        payload,
        meta
    );
}

export function setRegistryItemRemainingQuantity(payload, meta) {
    return createAction(
        ENUMS.SET_REGISTRY_ITEM_REMAINING_QUANTITY,
        payload,
        meta
    );
}

export function setPurchasedQuantity(payload, meta) {
    return createAction(
        ENUMS.SET_PURCHASED_QUANTITY,
        payload,
        meta
    );
}

export function setRegistries(payload, meta) {
    return createAction(
        ENUMS.SET_REGISTRIES,
        payload,
        meta
    );
}

export function showProductRegistries(payload, meta) {
    return createAction(
        PRODUCT_REGISTRY_ENUMS.SHOW_PRODUCT_REGISTRIES,
        merge(
            payload,
            {
                showProductRegistries: true
            }
        ),
        meta
    );
}
